import { render, staticRenderFns } from "./LoadingView.vue?vue&type=template&id=5472c060"
import script from "./LoadingView.vue?vue&type=script&lang=ts"
export * from "./LoadingView.vue?vue&type=script&lang=ts"
import style0 from "./LoadingView.vue?vue&type=style&index=0&id=5472c060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports